import Select from '../ConfigurazioneNora/Select'
import {
  descriviStima,
  motivoNonLanciabile,
  nomeFlusso,
  nomePredefinito,
  PRESET_CATALOGO,
  stimaCampagna
} from './Functions'
import { GruppoScenari } from './GruppoScenari'
import { Icona } from './Icon'
import { t } from './testi'

/** Passo numerato del form: titolo breve e, sotto, il suo contenuto. */
const Passo = ({ numero, titolo, aiuto, children }) => (
  <section className="ae-passo">
    <h4 className="ae-passo__titolo">
      <span className="ae-passo__numero" aria-hidden="true">
        {numero}
      </span>
      {titolo}
    </h4>
    {aiuto ? <p className="ae-muto ae-passo__aiuto">{aiuto}</p> : null}
    {children}
  </section>
)

/** Gli environment come chip: il primo scelto è quello su cui girano i comuni. */
const SceltaEnvironment = ({ environments, modulo }) => {
  const { form, perEnvironment, commutaEnvironment } = modulo
  return (
    <>
      <div className="ae-chips" role="group" aria-label={t.aeEnvironments}>
        {environments.map(({ id, codSociety, societyName }) => {
          const posizione = form.environmentIds.indexOf(String(id))
          const voce = perEnvironment.find((v) => String(v.environmentId) === String(id))
          const mode = voce?.catalogo?.ambiente?.mode
          return (
            <button
              key={id}
              type="button"
              className={`ae-chip ${posizione >= 0 ? 'is-scelta' : ''}`}
              aria-pressed={posizione >= 0}
              onClick={() => commutaEnvironment(id)}
            >
              {posizione >= 0 ? <Icona nome="pi-check" /> : null}
              <span>
                {id} · {societyName || codSociety}
              </span>
              {posizione >= 0 && mode ? (
                <span className="ae-chip__meta">{nomeFlusso(mode)}</span>
              ) : null}
              {posizione === 0 && form.environmentIds.length > 1 ? (
                <span className="nbadge nbadge--info">{t.aePrimoComuni}</span>
              ) : null}
            </button>
          )
        })}
      </div>
      {perEnvironment.some((v) => v.isError) ? (
        <p className="ae-errore" role="alert">
          {t.aeCatalogoEnvNonLetto}
        </p>
      ) : null}
    </>
  )
}

/** Il catalogo: ricerca, preset, seleziona/deseleziona e i gruppi comuni / di flusso. */
const CatalogoScenari = ({ modulo }) => {
  const {
    form,
    commuta,
    filtroCatalogo,
    setFiltroCatalogo,
    scegliPreset,
    selezionaVisibili,
    deseleziona,
    scenariQuery,
    catalogo,
    cataloghiPronti,
    fallitiUltima,
    visibili,
    gruppi,
    piano
  } = modulo
  const sezioni = [
    { titolo: t.aeComuni, aiuto: t.aeComuniAiuto, blocchi: gruppi.comuni },
    { titolo: t.aeDiFlusso, aiuto: t.aeDiFlussoAiuto, blocchi: gruppi.flussi }
  ].filter(({ blocchi }) => blocchi.length)
  return (
    <>
      <div className="ae-catalogo-barra">
        <input
          className="ninput"
          type="search"
          placeholder={t.aeCerca}
          aria-label={t.aeCerca}
          value={filtroCatalogo.testo}
          onChange={(e) => setFiltroCatalogo((f) => ({ ...f, testo: e.target.value }))}
        />
        <div className="ae-preset" role="group" aria-label={t.aePreset}>
          {PRESET_CATALOGO.map((preset) => (
            <button
              key={preset}
              type="button"
              className={`nbtn nbtn--sm ${
                filtroCatalogo.preset === preset ? 'nbtn--primary' : 'nbtn--ghost'
              }`}
              aria-pressed={filtroCatalogo.preset === preset}
              disabled={preset === 'falliti' && !fallitiUltima.length}
              title={preset === 'falliti' && !fallitiUltima.length ? t.aeNessunFallito : ''}
              onClick={() => scegliPreset(preset)}
            >
              {t[`aePreset_${preset}`]}
            </button>
          ))}
        </div>
      </div>
      <div className="ae-catalogo-conteggio" aria-live="polite">
        <span>
          {form.scenari.length
            ? `${form.scenari.length} ${t.aeScenariScelti}`
            : `${t.aeTuttiApplicabili}: ${visibili.length}`}
        </span>
        <button
          type="button"
          className="ae-link"
          onClick={selezionaVisibili}
          disabled={!visibili.length}
        >
          {t.aeSelezionaVisibili}
        </button>
        <button
          type="button"
          className="ae-link"
          onClick={deseleziona}
          disabled={!form.scenari.length}
        >
          {t.aeDeseleziona}
        </button>
      </div>
      {scenariQuery.isLoading ? <p className="ae-muto">{t.caricamento}</p> : null}
      {!scenariQuery.isLoading && !visibili.length ? (
        <p className="ae-muto ae-vuoto">{t.aeNessunoScenario}</p>
      ) : null}
      <div className="ae-catalogo-lista">
        {sezioni.map(({ titolo, aiuto, blocchi }) => (
          <section key={titolo} className="ae-catalogo-sezione">
            <h5 className="ae-macro__titolo">{titolo}</h5>
            <p className="ae-muto">{aiuto}</p>
            <div className="ae-gruppi">
              {blocchi.map(({ nome, scenari }) => (
                <GruppoScenari
                  key={nome}
                  nome={nome}
                  scenari={scenari}
                  selezionati={form.scenari}
                  ricerca={filtroCatalogo.testo}
                  onCommuta={commuta}
                  piano={piano}
                  mostraDove={Boolean(form.environmentIds.length && cataloghiPronti)}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
      {catalogo?.invalidi?.map((i) => (
        <div key={i.file} className="ae-errore">
          {t.aeNonValido} {i.file}: {i.errore}
        </div>
      ))}
    </>
  )
}

/**
 * Il form «Nuova run» in tre passi (dove, cosa, come). La barra con «Avvia» e la stima resta
 * incollata in fondo alla card, così il bottone si raggiunge anche con il catalogo lungo; se è
 * spento dice perché.
 * @param {Object} props - Proprietà
 * @param {Object} props.modulo - Il risultato di `useModuloLancio`
 * @param {Array<Object>} props.environments - Gli environment
 * @param {Object} props.misure - `misureTestata` (per la stima)
 * @param {Array<Object>} props.runs - Le run lette (per la stima)
 * @param {boolean} props.invio - Il lancio è in corso
 * @param {() => void} props.onLancia - Avvia
 */
export const FormLancio = ({ modulo, environments, misure, runs, invio, onLancia }) => {
  const { form, aggiorna, cataloghiPronti, piano, esecuzioniPiano } = modulo
  const motivo = motivoNonLanciabile(
    {
      ambienti: form.environmentIds.length,
      pronti: cataloghiPronti,
      esecuzioni: esecuzioniPiano,
      invio
    },
    t
  )
  const pronto = !motivo && !invio
  return (
    <div className="ncard ae-lancia-card">
      <div className="ncard__head">
        <div>
          <h3 className="ncard__title">{t.aeLancia}</h3>
          <div className="ncard__sub">{t.aeLanciaSotto}</div>
        </div>
      </div>
      <div className="ncard__body ae-form">
        <Passo
          numero={1}
          titolo={`${t.aePassoEnv} · ${t.aeEnvironments}`}
          aiuto={t.aeEnvironmentsAiuto}
        >
          <SceltaEnvironment environments={environments} modulo={modulo} />
        </Passo>
        <Passo numero={2} titolo={`${t.aePassoScenari} · ${t.aeScenari}`}>
          <CatalogoScenari modulo={modulo} />
        </Passo>
        <Passo numero={3} titolo={`${t.aePassoOpzioni} · ${t.aeRipetizioni} / ${t.aeRicerca}`}>
          <div className="ae-opzioni">
            <div className="nfield">
              <label htmlFor="ae-ripetizioni">{t.aeRipetizioni}</label>
              <input
                id="ae-ripetizioni"
                className="ninput"
                type="number"
                min="1"
                max="200"
                placeholder={t.aeRipetizioniScenario}
                value={form.ripetizioni}
                onChange={(e) => aggiorna('ripetizioni', e.target.value)}
              />
            </div>
            <div className="nfield">
              <label htmlFor="ae-ricerca">{t.aeRicerca}</label>
              <Select id="ae-ricerca" value={form.ricerca} onChange={(v) => aggiorna('ricerca', v)}>
                <option value="finta">{t.aeRicercaFinta}</option>
                <option value="reale">{t.aeRicercaReale}</option>
              </Select>
            </div>
            <div className="nfield">
              <label htmlFor="ae-google">{t.aeGoogle}</label>
              <Select id="ae-google" value={form.google} onChange={(v) => aggiorna('google', v)}>
                <option value="auto">{t.aeGoogleAuto}</option>
                <option value="replay">{t.aeGoogleReplay}</option>
                <option value="record">{t.aeGoogleRecord}</option>
                <option value="live">{t.aeGoogleLive}</option>
              </Select>
            </div>
            <div className="nfield ae-opzioni__nome">
              <label htmlFor="ae-nome">{t.aeNome}</label>
              <input
                id="ae-nome"
                className="ninput"
                maxLength={80}
                placeholder={nomePredefinito(form.environmentIds)}
                value={form.nome}
                onChange={(e) => aggiorna('nome', e.target.value)}
              />
            </div>
          </div>
          {form.ricerca === 'reale' ? <p className="ae-avviso">{t.aeRicercaRealeAvviso}</p> : null}
          <label className="ae-spunta">
            <input
              type="checkbox"
              checked={form.trascrizioni}
              onChange={(e) => aggiorna('trascrizioni', e.target.checked)}
            />{' '}
            {t.aeTrascrizioni}
          </label>
        </Passo>
      </div>
      <div className="ae-lancio">
        <button type="button" className="nbtn nbtn--primary" disabled={!pronto} onClick={onLancia}>
          <Icona nome={invio ? 'pi-spin pi-spinner' : 'pi-play'} />{' '}
          {form.environmentIds.length > 1 ? t.aeAvviaCampagna : t.aeAvvia}
        </button>
        <span className="ae-stima" aria-live="polite">
          {motivo ||
            (cataloghiPronti
              ? descriviStima(stimaCampagna(esecuzioniPiano, misure, runs), piano, {
                  esecuzioni: t.aeEsecuzioni,
                  minuti: t.aeMinuti
                })
              : '')}
        </span>
      </div>
    </div>
  )
}
